import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { useStyles } from './NoRecords.styles';

interface NoRecordsProps {
  iconOnTop?: boolean;
  withMargin?: string | boolean;
}

export const NoRecords: React.FC<NoRecordsProps> = ({ iconOnTop, withMargin }) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.noRecordsMessage} ${!iconOnTop ? classes.iconOnLeft : undefined}`}
      style={withMargin !== undefined && withMargin !== false ? { paddingTop: typeof withMargin === 'string' ? withMargin : '200px' } : undefined}
    >
      <SearchIcon className={classes.noRecordsIcon} />
      <div>Nie znaleziono rekordów spełniających zadane kryteria wyszukiwania/filtrowania</div>
    </div>
  );
};
